import { parseLogDate } from './parseLogDate';

import { LOG_NULL_USER_ID } from '../constants';

/**
 * Gets user ID/event type/date from a log's S3 object key
 * @param   {string} logKeyArg An eventbridge log's S3 object key
 * @returns {LogEvent} An object with all parsable information from an S3 object key
 */
export const parseLogKeyData = (logKeyArg: string): LogEvent => {
    let logKey = logKeyArg;

    if (logKey[0] === '/') {
        logKey = LOG_NULL_USER_ID + logKey; // Workaround for S3 keys with empty string as user ID
    }
    const keyData = {} as LogEvent;
    const idRegex = `(^(.)([^/])+)`;
    const dateRegex = `/([_0-9]+)_`;
    const eventTypeRegex = `_([a-zA-Z]+)_|_([a-zA-Z]+)`;
    const eventStatusRegex = `_[a-zA-Z]+_(([a-zA-Z])+?(?=.json))`;

    keyData.key = logKey;

    const parsedUserId = logKey.match(idRegex);

    keyData.userId = parsedUserId ? parsedUserId[0] : '';

    const dateFromKey = logKey.match(dateRegex);
    const parsedDate = dateFromKey ? parseLogDate(dateFromKey[1]) : new Date();
    const formattedDate = parsedDate
        ? parsedDate
              .toLocaleString('en', { hour12: false })
              .replace(/,\s(24):/, ', 00:')
        : '';

    keyData.date = parsedDate ? formattedDate : '';
    keyData.dateData = parsedDate;

    const parsedEventType = logKey.match(eventTypeRegex);

    keyData.eventType = parsedEventType
        ? parsedEventType.find(match => match && !match.startsWith('_')) ?? ''
        : '';

    const parsedEventStatus = logKey.match(eventStatusRegex);

    keyData.eventStatus = parsedEventStatus
        ? parsedEventStatus.find(match => match && !match.startsWith('_')) ?? ''
        : 'Not Available From Key';

    keyData.isValid =
        keyData.userId !== '' &&
        keyData.date !== '' &&
        keyData.eventType !== '';

    return keyData;
};
